import React from 'react';
import { Text } from 'basis';
import { isFeatureOn } from 'featureToggles';

export const MinimumMonthlyPaymentDisclaimer = ({ includeOutstandingBalanceMessage = true }) => {
  if (!isFeatureOn('auDisclaimer')) return null;
  return (
    <Text margin="2 0 0 0">
      <strong>Note:{'\u00A0'}</strong>
      Effective from 15 July 2026, the minimum monthly payment will change to the greater of $30 or 2.75% of your
      closing balance.
      {includeOutstandingBalanceMessage && ' If your outstanding balance is less than $30, you must pay that balance.'}
    </Text>
  );
};

export const CreditCardFeeDisclaimer = () => {
  if (!isFeatureOn('auDisclaimer')) return null;
  return (
    <Text margin="2 0 0 0">
      <strong>Note:</strong> Effective from 15 July 2026, the credit card fee will increase to $11.95.
    </Text>
  );
};
